import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, Field } from '../ui/Modal';
import { Icon } from '../ui/Icon';
import { api, ApiError } from '../../lib/api';
import { toast } from '../../stores/toast.store';
import { VaultCategory } from '@masamune/shared';

export function NewVaultModal({ onClose }: { onClose: () => void }) {
  const qc = useQueryClient();
  const [form, setForm] = useState({
    label: '', category: VaultCategory.PIATTAFORMA_CLIENTE as string,
    username: '', password: '', url: '', notes: '',
  });
  const [show, setShow] = useState(false);

  const create = useMutation({
    mutationFn: () => api.post('/vault', { ...form, allowedRoleIds: [] }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['vault'] });
      toast.ok('Credenziale salvata', form.label);
      onClose();
    },
    onError: (err) => toast.alert('Errore salvataggio vault', err instanceof ApiError ? err.message : 'Riprova'),
  });

  return (
    <Modal
      title="Nuova voce vault"
      kicker="Sicurezza · Credenziali"
      onClose={onClose}
      size="md"
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <div className="spacer" />
          <button className="btn btn-primary" onClick={() => create.mutate()} disabled={!form.label || !form.password || create.isPending}>
            Salva cifrata <Icon name="lock" size={12} />
          </button>
        </>
      }
    >
      <div className="form-grid">
        <Field label="Etichetta" required span={12}>
          <input className="inp" value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} />
        </Field>
        <Field label="Categoria" span={12}>
          <select className="inp" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
            {Object.values(VaultCategory).map((c) => <option key={c} value={c}>{c.replace(/_/g, ' ')}</option>)}
          </select>
        </Field>
        <Field label="Username" span={6}>
          <input className="inp" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
        </Field>
        <Field label="URL" span={6}>
          <input className="inp" placeholder="https://" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} />
        </Field>
        <Field label="Password" required span={12}>
          <div className="flex gap-1">
            <input className="inp mono flex-1" type={show ? 'text' : 'password'} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <button className="btn btn-sm btn-ghost" onClick={() => setShow(!show)}>
              <Icon name={show ? 'eyeOff' : 'eye'} size={12} />
            </button>
          </div>
        </Field>
        <Field label="Note" span={12}>
          <textarea className="inp" rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
        </Field>
      </div>
      <div className="mt-3 text-[12px] mute flex items-center gap-1.5">
        <Icon name="lock" size={12} />
        Cifrato AES-256-GCM lato server. La chiave master non è memorizzata né recuperabile.
      </div>
    </Modal>
  );
}
